export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "volume.worker.0a09e67c953f14fd9654.bundle.worker.js");
}
